import React, { useEffect, useState } from 'react';
import ReactApexChart from "react-apexcharts";



const AreaChart = ({ seriesChart, labelChart, colorsChart, height }) => {
    

    var options = {
        chart: {
            type: 'area',
            height: height,
            zoom: {
                enabled: false
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'straight'
        },
        labels: labelChart,
        xaxis: {
            type: 'datetime',
        },
        yaxis: {
            opposite: true
        },
        legend: {
            horizontalAlign: 'left'
        },
        colors: colorsChart
    };

    return (
        <React.Fragment>
            <ReactApexChart dir="ltr"
                options={options}
                series={seriesChart}
                type="area"
                height={height}
                className="apex-charts"
            />
        </React.Fragment>
    );
};


export default AreaChart;